export default {
  getStaffIndividualAttendanceList: (state) => state.items,
  getStaffIndividualAttendanceListBusy: (state) => state.isBusy,
  getStaffIndividualAttendanceListPagination: (state) => state.pagination,
};
